export const FETCH_LIVE_INFO_PROMO = 'HOME/FETCH_LIVE_INFO_PROMO';
